const Z = {
    WALL: 10,
    OPENING: 30,
    ARCH_OTHER: 20,
    MEP: 40,
};
export const IFC_INSTANCE_CLASS_META = {
    IfcWall: { label: "Vegg", color: "#9AA0A6", zIndex: Z.WALL, discipline: "ARK" },
    IfcWallStandardCase: { label: "Vegg", color: "#9AA0A6", zIndex: Z.WALL, discipline: "ARK" },
    IfcDoor: { label: "Dør", color: "#8B6B4F", zIndex: Z.OPENING, discipline: "ARK" },
    IfcWindow: { label: "Vindu", color: "#10D5D5", zIndex: Z.OPENING, discipline: "ARK" },
    IfcShadingDevice: {
        label: "Solskjerming",
        color: "#6FA8DC",
        zIndex: Z.OPENING,
        discipline: "ARK",
    },
    IfcColumn: { label: "Søyle", color: "#2F2F2F", zIndex: Z.ARCH_OTHER, discipline: "ARK" },
    IfcBeam: { label: "Bjelke", color: "#4A4A4A", zIndex: Z.ARCH_OTHER, discipline: "ARK" },
    IfcMember: { label: "Stålprofil", color: "#555555", zIndex: Z.ARCH_OTHER, discipline: "ARK" },
    IfcRailing: { label: "Rekkverk", color: "#808080", zIndex: Z.ARCH_OTHER, discipline: "ARK" },
    IfcTransportElement: {
        label: "Heis / transport",
        color: "#7F8C8D",
        zIndex: Z.ARCH_OTHER,
        discipline: "ARK",
    },
    IfcFurniture: { label: "Møbler", color: "#E6E1D6", zIndex: Z.ARCH_OTHER, discipline: "ARK" },
    IfcAirTerminal: { label: "Luftdon", color: "#1E88E5", zIndex: Z.MEP, discipline: "RIV" },
    IfcPipeFitting: { label: "Rørdel", color: "#1976D2", zIndex: Z.MEP, discipline: "RIV" },
    IfcDuctFitting: { label: "Kanaldel", color: "#1565C0", zIndex: Z.MEP, discipline: "RIV" },
    IfcDuctSegment: {
        label: "Ventilasjonskanal",
        color: "#1976D2",
        zIndex: Z.MEP,
        discipline: "RIV",
    },
    IfcDamper: { label: "Spjeld", color: "#1565C0", zIndex: Z.MEP, discipline: "RIV" },
    IfcDuctSilencer: { label: "Lydboks", color: "#1E5AA8", zIndex: Z.MEP, discipline: "RIV" },
    IfcFan: { label: "Vifte", color: "#26A69A", zIndex: Z.MEP, discipline: "RIV" },
    IfcFilter: { label: "Filter", color: "#2ECC71", zIndex: Z.MEP, discipline: "RIV" },
    IfcCoil: { label: "Batteri", color: "#2E7D32", zIndex: Z.MEP, discipline: "RIV" },
    IfcChiller: { label: "Kjølemaskin", color: "#26A69A", zIndex: Z.MEP, discipline: "RIV" },
    IfcCooledBeam: { label: "Kjølebaffel", color: "#00ACC1", zIndex: Z.MEP, discipline: "RIV" },
    IfcUnitaryEquipment: { label: "Aggregat", color: "#00897B", zIndex: Z.MEP, discipline: "RIV" },
    IfcUnitaryControlElement: {
        label: "Reguleringsenhet",
        color: "#00796B",
        zIndex: Z.MEP,
        discipline: "RIV",
    },
    IfcPipeSegment: { label: "Rør", color: "#2D9CDB", zIndex: Z.MEP, discipline: "RIV" },
    IfcValve: { label: "Ventil", color: "#2E86C1", zIndex: Z.MEP, discipline: "RIV" },
    IfcFlowMeter: { label: "Måler", color: "#00BFA5", zIndex: Z.MEP, discipline: "RIV" },
    IfcFlowInstrument: { label: "Instrument", color: "#00B8D4", zIndex: Z.MEP, discipline: "RIV" },
    IfcSanitaryTerminal: { label: "Sanitær", color: "#4FC3F7", zIndex: Z.MEP, discipline: "RIV" },
    IfcWasteTerminal: { label: "Avløp", color: "#4DD0E1", zIndex: Z.MEP, discipline: "RIV" },
    IfcSpaceHeater: { label: "Radiator", color: "#EF5350", zIndex: Z.MEP, discipline: "RIV" },
    IfcFireSuppressionTerminal: {
        label: "Sprinkler",
        color: "#E53935",
        zIndex: Z.MEP,
        discipline: "RIV",
    },
    IfcLightFixture: { label: "Lysarmatur", color: "#F4C542", zIndex: Z.MEP, discipline: "RIE" },
    IfcSwitchingDevice: { label: "Bryter", color: "#F39C12", zIndex: Z.MEP, discipline: "RIE" },
    IfcOutlet: { label: "Stikkontakt", color: "#F1C40F", zIndex: Z.MEP, discipline: "RIE" },
    IfcJunctionBox: { label: "Koblingsboks", color: "#E67E22", zIndex: Z.MEP, discipline: "RIE" },
    IfcCableCarrierSegment: {
        label: "Kabelstige/-kanal",
        color: "#D35400",
        zIndex: Z.MEP,
        discipline: "RIE",
    },
    IfcCableSegment: { label: "Kabel", color: "#E67E22", zIndex: Z.MEP, discipline: "RIE" },
    IfcCableFitting: { label: "Kabeldel", color: "#CA6F1E", zIndex: Z.MEP, discipline: "RIE" },
    IfcCableCarrierFitting: {
        label: "Kabelstagedel",
        color: "#BA4A00",
        zIndex: Z.MEP,
        discipline: "RIE",
    },
    IfcElectricDistributionBoard: {
        label: "Tavle",
        color: "#F39C12",
        zIndex: Z.MEP,
        discipline: "RIE",
    },
    IfcProtectiveDevice: {
        label: "Sikring/vern",
        color: "#D68910",
        zIndex: Z.MEP,
        discipline: "RIE",
    },
    IfcElectricAppliance: { label: "El-utstyr", color: "#F8C471", zIndex: Z.MEP, discipline: "RIE" },
    IfcCommunicationsAppliance: {
        label: "Tele/IT-utstyr",
        color: "#BB8FCE",
        zIndex: Z.MEP,
        discipline: "RIE",
    },
    IfcAudioVisualAppliance: {
        label: "AV-utstyr",
        color: "#AF7AC5",
        zIndex: Z.MEP,
        discipline: "RIE",
    },
    IfcAlarm: { label: "Alarm", color: "#E74C3C", zIndex: Z.MEP, discipline: "RIE" },
    IfcController: { label: "Controller", color: "#8E44AD", zIndex: Z.MEP, discipline: "RIE" },
    IfcSensor: { label: "Sensor", color: "#8E44AD", zIndex: Z.MEP, discipline: "RIE" },
    IfcMedicalDevice: {
        label: "Medisinsk utstyr",
        color: "#9B59B6",
        zIndex: Z.MEP,
        discipline: "RIE",
    },
    IfcDiscreteAccessory: { label: "Tilbehør", color: "#95A5A6", zIndex: Z.MEP, discipline: "RIV" },
    IfcElementAssembly: {
        label: "Sammenstilling",
        color: "#95A5A6",
        zIndex: Z.ARCH_OTHER,
        discipline: "ARK",
    },
};
const DEFAULT_META = {
    label: "Ukjent",
    color: "#9AA0A6",
    discipline: "ARK",
};
const DEFAULT_Z_INDEX = 20;
export const getInstanceClassMeta = (instanceClass) => {
    return IFC_INSTANCE_CLASS_META[instanceClass] ?? DEFAULT_META;
};
export const getInstanceClassZIndex = (instanceClass) => {
    return IFC_INSTANCE_CLASS_META[instanceClass]?.zIndex ?? DEFAULT_Z_INDEX;
};
